import { Component } from '@angular/core';
import { navigationMenu } from '../../_constants/constants';
import { AuthService } from '../../../auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-side-navigation',
  templateUrl: './side-navigation.component.html',
  styleUrls: ['./side-navigation.component.scss'],
})
export class SideNavigationComponent {
  navigationMenu: any[] = navigationMenu;
  hoveredItemIndex: any;
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}
}
